import styled from "@emotion/styled";
import React from "react";
import Loading from "./Loading";

export default function LoadingAbsolute(
  props: React.DetailedHTMLProps<
    React.HTMLAttributes<HTMLDivElement>,
    HTMLDivElement
  >
): JSX.Element {
  const Root = styled.div`
    position: fixed;
    top: 0;
    left: 0;

    width: 100vw;
    height: 100vh;

    display: flex;
    justify-content: center;
    align-items: center;

    background-color: #00000066;
    z-index: 9999;
    padding-bottom: 40px;
    overflow-y: auto;
  `;

  return (
    <Root>
      <Loading {...props} />
    </Root>
  );
}
